import {push} from "connected-react-router";
import { CONFIRMATION_ROUTE} from "../components/Root/routes";

const showConfirmation= () => async (dispatch) =>
{
    dispatch(push(CONFIRMATION_ROUTE));
};
export default showConfirmation;